import { createContext, useContext, useEffect, useRef, useState } from "react";
import * as authHelper from "../api/loginAction";
import { fetchIPAddress, getUserData, login } from "../api/loginapi";
import SplashScreen from "./SplashScreen";

const initAuthContextPropsState = {
  auth: authHelper.getAuth(),
  saveAuth: () => { },
  currentUser: undefined,
  setCurrentUser: () => { },
  logout: () => { },
};

const AuthContext = createContext(initAuthContextPropsState);

const useAuth = () => {
  return useContext(AuthContext);
};

const fontCss = {
  color: "#181a20",
  fontWeight: "bold",
};

const AuthProvider = ({ children }) => {
  const [auth, setAuth] = useState(authHelper.getAuth());
  const [currentUser, setCurrentUser] = useState();

  const saveAuth = (auth) => {
    setAuth(auth);
    if (auth) {
      authHelper.setAuth(auth);
    } else {
      authHelper.removeAuth();
    }
  };

  const logout = () => {
    // localStorage.removeItem("UserData");
    const platform = localStorage.getItem("platform");
    localStorage.clear();
    if (platform) {
      localStorage.setItem("platform", platform);
    }
    sessionStorage.clear();
    saveAuth(undefined);
    setCurrentUser(undefined);
    // window.location.reload();
  };

  return (
    <AuthContext.Provider
      value={{ auth, saveAuth, currentUser, setCurrentUser, logout }}
    >
      {children}
    </AuthContext.Provider>
  );
};

const AuthInit = ({ children }) => {
  const { auth, logout, setCurrentUser, saveAuth } = useAuth();
  const didRequest = useRef(false);
  const [showSplashScreen, setShowSplashScreen] = useState(true);
  const [splashScreenError, setSplashScreenError] = useState(null);

  useEffect(() => {
    const requestUser = async () => {
      try {
        if (!didRequest.current) {
          const data = getUserData();

          if (data) {
            setCurrentUser(data);
          }
        }
      } catch (error) {
        console.error(error);
        if (!didRequest.current) {
          logout();
        }
      } finally {
        setShowSplashScreen(false);
      }

      return () => (didRequest.current = true);
    };

    const handleAutoLogin = async (telegramid, accesscode) => {
      try {
        const ipRes = await fetchIPAddress();
        const queryParams = {
          action: "agentlogin_telegram",
          telegramid: telegramid,
          accesscode: accesscode,
          ipaddress: ipRes.ip,
          projectid: process.env.REACT_APP_PROJECT_ID,
        };

        const resp = await login(queryParams, true);

        if (parseInt(resp.code) === 0) {
          const params = new URLSearchParams(window.location.search);
          saveAuth({ ...resp, fullName: decodeURIComponent(params.get("fullname")), profilePic: decodeURIComponent(params.get("profileimage")) });
          setCurrentUser({ ...resp, fullName: decodeURIComponent(params.get("fullname")), profilePic: decodeURIComponent(params.get("profileimage")) });
          localStorage.setItem("permissions", JSON.stringify(resp.agentPermissions));
          localStorage.setItem("role", resp.role);
          window.history.replaceState({}, document.title, window.location.pathname);
          setShowSplashScreen(false);
        } else {
          console.error("Auto login failed", resp.message);
          logout();
          setShowSplashScreen(true);
          setSplashScreenError(resp.message);
        }
      } catch (error) {
        console.error("Auto login error", error);
        logout();
        setShowSplashScreen(true);
        setSplashScreenError("Login Failed");
      } finally {
        // showSplashScreen is handled in success/error blocks.
      }
    };

    const params = new URLSearchParams(window.location.search);
    const platformParam = params.get("platform");
    if (platformParam) {
      localStorage.setItem("platform", platformParam);
    }
    const currentPlatform = localStorage.getItem("platform");

    if (currentPlatform === "telegram") {
      const telegramid = params.get("telegramid");
      const accesscode = params.get("accesscode");

      if (telegramid && accesscode) {
        handleAutoLogin(telegramid, accesscode);
      } else {
        setShowSplashScreen(!auth);
        setSplashScreenError("Session End");
      }
    } else if (auth) {
      requestUser();
    } else {
      logout();
      setShowSplashScreen(false);
    }
    // eslint-disable-next-line
  }, []);

  return showSplashScreen ? <SplashScreen error={splashScreenError} /> : <>{children}</>;
};

export { AuthInit, AuthProvider, fontCss, useAuth };

